import React from "react";

const Header = () => {
  const announcement =
    "Welcome to Trinity High School . Our Student Got National First Prize in JCI NLTS .";

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="img-responsive">
              <img
                src="assets/logos/logo.jpg"
                alt=""
                className="img-responsive"
                width="100%"
              />
            </div>
          </div>
        </div>
      </div>
      {announcement && (
        <div className="container-fluid bg-light overflow-hidden">
          <div className="marquee-wrapper" aria-live="polite">
            <div className="marquee-content">
              <span>{announcement}</span>
            </div>
          </div>

          <style>{`
      .marquee-wrapper {
        overflow: hidden;
        position: relative;
        white-space: nowrap;
      }

      .marquee-content {
        display: inline-block;
        padding-left: 100%;
        animation: marquee 20s linear infinite;
        color: #0460a4;
      }

      .marquee-wrapper:hover .marquee-content {
        animation-play-state: paused;
      }

      @keyframes marquee {
        0% {
          transform: translateX(0%);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `}</style>
        </div>
      )}
    </>
  );
};

export default Header;
